import type { ApolloClient } from '@apollo/client';
import { QueryClient } from '@tanstack/react-query';

import { getAppSyncErrorType } from './utils/getAppSyncErrorType';

const MOST_RETRIES = 3;

/** An AppSync refusal (Unauthorized, or any batch tracking code) is answered the same again; only a failure to reach the server is retried. */
export const retryNetworkErrors = (failures: number, error: Error): boolean =>
  getAppSyncErrorType(error) === undefined && failures < MOST_RETRIES;

export const queryClient = new QueryClient({ defaultOptions: { queries: { retry: retryNetworkErrors } } });

/**
 * Drops everything read for the signed-in account, from both caches: sign-out, a lost session, a revoked kitchen.
 * One place, so a reset cannot clear one cache and leave the other holding another account's data. Never rejects.
 */
export const clearPrivateData = (apollo: ApolloClient, queries: QueryClient): Promise<unknown> => {
  apollo.cache.restore({});
  queries.clear();
  return Promise.allSettled([apollo.clearStore()]);
};
